export function getVacancies (state) {
  return state.vacancies
}

export function getVacancyEntry (state) {
  return state.entry
}

export function getSimilarVacancies (state) {
  return state.similarVacancies
}



// WEBPACK FOOTER //
// ./src/vuex/vacancies/getters.js